import { withStyles } from '@material-ui/core/styles';
import CardContent from '@material-ui/core/CardContent';

export default withStyles({
  root: {
    padding: '10px',
  },
})(CardContent);
